<article class="post">
  <!--  <img src="{{post?.urlGenerica}}" [routerLink]="['/blogs', urlBlog, 'posts', post?.tituloVideo | kebabCase]" >-->
  <a class="header-article" [routerLink]="['/blogs', urlBlog, 'posts', post?.idVideo, post?.tituloSeo | kebabCase]">
    <div class="contenedor-info-noticia">
      <div class="container-img">
        @if (post?.urlGenerica) {
          <img [src]="post?.urlGenerica" alt="post?.tituloVideo" width="100%" height="100%" />
        }

        @if (!post?.urlGenerica) {
          <img [src]="config.logo" alt="logo" style="background-color: #282d38; object-fit: contain" width="100%" height="100%" />
        }
      </div>

      <h1>{{ post?.tituloVideo }}</h1>

      <!--    <p class="description-article" [innerHTML]="post?.entradillaVideo" [routerLink]="['/blogs', urlBlog, 'posts', post?.tituloVideo | kebabCase]"></p>-->
      <div class="footer-article">
        <span class="canal-noticia" [routerLink]="['/canal', post?.idCanal, post?.canal | kebabCase]">{{ post?.canal }}</span>
        @for (tag of post?.tags | slice: 0 : 2; track tag) {
          <span class="tag-noticia" [routerLink]="['/tag', $any(tag) | kebabCase]">{{ tag }} <span class="separador"> | </span></span>
        }
        {{ formatDate(post?.fecha) | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
  </a>
</article>
